import { suggestEmail } from "../utils/EmailSuggestion";

// x-email-suggestion on an email input: when the customer leaves the field,
// offer a fix for a likely typo ("Did you mean jo@gmail.com?"). One tap
// accepts it; it never blocks submitting. The hint is a polite live region so
// screen readers hear it too.
export const emailSuggestion = (el, _, { cleanup }) => {
    const hint = document.createElement("p");
    hint.className = "email-suggestion";
    hint.setAttribute("aria-live", "polite");
    el.insertAdjacentElement("afterend", hint);

    const clear = () => hint.replaceChildren();

    const suggest = () => {
        const suggestion = suggestEmail(el.value);
        if (!suggestion) {
            clear();
            return;
        }

        const accept = document.createElement("button");
        accept.type = "button";
        accept.textContent = suggestion;
        accept.addEventListener("click", () => {
            el.value = suggestion;
            // Lets x-model (and anything else listening) pick up the change.
            el.dispatchEvent(new Event("input", { bubbles: true }));
            el.dispatchEvent(new Event("change", { bubbles: true }));
            clear();
            el.focus();
        });

        hint.replaceChildren("Did you mean ", accept, "?");
    };

    el.addEventListener("blur", suggest);
    el.addEventListener("input", clear);

    cleanup(() => {
        el.removeEventListener("blur", suggest);
        el.removeEventListener("input", clear);
        hint.remove();
    });
};
